export enum ChangeRequestType {
    address = "address",
    stateTax = "stateTax",
    federalTax = 'federalTax',
}

export enum ChangeRequestStatus {
    submitted = 1,
    approved = 2,
    denied= 3,
    cancelled = 4,
    superseded = 5,
}